interface GoogleIdentity {
  initialize: (options: {
    client_id: string
    nonce: string
    auto_select: boolean
    callback: (response: { credential: string }) => void
  }) => void
  renderButton: (element: HTMLElement, options: {
    type: 'standard'; theme: 'outline'; size: 'large'; text: 'continue_with'; locale: string; width: number
  }) => void
}

declare global {
  interface Window {
    google?: { accounts: { id: GoogleIdentity } }
  }
}

let loading: Promise<GoogleIdentity> | undefined

export function loadGoogleIdentity(): Promise<GoogleIdentity> {
  if (window.google?.accounts.id) return Promise.resolve(window.google.accounts.id)
  if (loading) return loading
  loading = new Promise<GoogleIdentity>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    const fail = () => {
      clearTimeout(timeout)
      script.remove()
      loading = undefined
      reject(new Error('GOOGLE_SCRIPT_UNAVAILABLE'))
    }
    const timeout = window.setTimeout(fail, 15000)
    script.onerror = fail
    script.onload = () => {
      if (!window.google?.accounts.id) { fail(); return }
      clearTimeout(timeout)
      resolve(window.google.accounts.id)
    }
    document.head.appendChild(script)
  })
  return loading
}
